export function cleanSuggestedActionsFromContent(text: string): string {
  let cleaned = text.replace(/\[SUGGESTED_ACTIONS\][\s\S]*?\[\/SUGGESTED_ACTIONS\]\s*$/, '');
  cleaned = cleaned.replace(/\[SUGGESTED_ACTIONS\][\s\S]*$/, '');
  cleaned = cleaned.replace(/\[SUGGESTED[-_A-Z]*$/i, '');
  return cleaned.trimEnd();
}
